var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-body" },
    [
      _c(
        "page-banner",
        _vm._b(
          { attrs: { image: _vm.bannerImage } },
          "page-banner",
          _vm.page.banner,
          false
        )
      ),
      _c(
        "page-limiter",
        { attrs: { id: "s-catalog" } },
        [
          _vm.crumbs && _vm.crumbs.length
            ? _c("breadcrumbs", { attrs: { crumbs: _vm.crumbs } })
            : _vm._e(),
          _c("h1", { staticClass: "page-title" }, [
            _vm._v(_vm._s(_vm.page.h1 || _vm.page.title))
          ]),
          _c(
            "div",
            { staticClass: "catalog-row" },
            [
              _c(
                "div",
                { staticClass: "catalog-row__aside" },
                [
                  _c("catalog-menu", {
                    attrs: {
                      tags: _vm.page.tagNav,
                      brands: _vm.page.brandNav,
                      types: _vm.page.typeNav,
                      filters: _vm.filters,
                      count: _vm.countLabel
                    }
                  })
                ],
                1
              ),
              _c("transition", { attrs: { name: "fade-fast" } }, [
                !_vm.isChangeAnimate
                  ? _c("div", { staticClass: "catalog-row__body" }, [
                      _c("section", { staticClass: "catalog-section" }, [
                        _c(
                          "ul",
                          { staticClass: "catalog-grid" },
                          _vm._l(_vm.itemsFiltered, function(item) {
                            return _c(
                              "li",
                              {
                                key: item.id,
                                class: [
                                  "catalog-grid__item",
                                  { "catalog-grid__item--wide": item.wide }
                                ]
                              },
                              [
                                _c("product-tile", { attrs: { content: item } })
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("page-content", { attrs: { page: _vm.page } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc7bf518", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc7bf518","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageCatalog.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-bc7bf518","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageCatalog.vue
// module chunks = 0